import React, { useEffect, useState } from 'react';

const ITEMS = [
  { id: 'top', label: 'Intro' },
  { id: 'about', label: 'About' },
  { id: 'work', label: 'Work' },
  { id: 'skills', label: 'Skills' },
  { id: 'contact', label: 'Contact' },
];

export default function Rail() {
  const [active, setActive] = useState('top');
  useEffect(() => {
    const onScroll = () => {
      const mid = window.scrollY + window.innerHeight * 0.35;
      let cur = ITEMS[0].id;
      ITEMS.forEach((it) => {
        const el = document.getElementById(it.id);
        if (el && el.offsetTop <= mid) cur = it.id;
      });
      setActive(cur);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return (
    <aside className="rail">
      {ITEMS.map((it) => (
        <a key={it.id} href={`#${it.id}`} className={active === it.id ? 'active' : ''}>
          <span className="dot" />
          <span className="lbl">{it.label}</span>
        </a>
      ))}
    </aside>
  );
}
